import { useState, useEffect } from 'react';

import ModalCadastroCertidao from './ModalManterTipoCertidao';
import TableSeplag from '../../components/TableSeplag';
import CardSeplag from '../../components/CardSeplag';
import RotuloSeplag from '../../components/RotuloSeplag';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useFormik } from "formik";

import {
  pesquisarAll as pesquisaAtivos,
  buscarPeloCodigo as buscarIdenCertidao,
  FormTipoCertidao as initForm,
  remover as deleteCertidao, pesquisar, buscarPeloCodigo, buscarPeloNome,
} from '../../service/manterTiposCertidao';



const ManterTipoCertidao = () => {

  const [formDataModalTipoCertidao, setFormDataModalTipoCertidao] = useState(initForm);
  const [edit, setEdit] = useState(false);
  const [showForm, setShowForm] = useState(false)
  const [viewCamposModalTipoCertidao, setViewCamposModalTipoCertidao] = useState(false);
  const [listaTipoCertidao, setlistaTipoCertidao] = useState([]);
  const [codigoFiltro, setCodigoFiltro] = useState('');
  const [nomeFiltro, setNomeFiltro] = useState('');

  const camposTabela = [
    { nome: "siglTipoCertidao", titulo: "Sigla" },
    { nome: "nomeTipoCertidao", titulo: "Nome do Tipo" },
  ];

  useEffect(async () => {
    let data = await pesquisaAtivos();

    setlistaTipoCertidao(data.map(function (element) {
      let novoElement = {
        ...element,
        amparoLegal: null,
        listaAmparoLegalTpCertidao: element.listaAmparoLegalTpCertidao.map(function (element2) {
          return { ...element2.amparoLegal }
        })
      }
      if (element.amparoLegal) {
        novoElement.listaAmparoLegalTpCertidao.push(element.amparoLegal)
      }
      return novoElement
    })
    );
  }, []);

  const handleShowModalAdicionarTipoCertidao = async () => {
    setShowForm(true);
    setViewCamposModalTipoCertidao(false);
    setEdit(false);

    let resetFormDataModalTipoCertidao = {
      amparoLegal: {
        idenAmparoLegal: null
      },
      codgTipoCertidao: null,
      nomeTipoCertidao: '',
      siglTipoCertidao: '',
      orgaoEmissor: null
    }

    setFormDataModalTipoCertidao(resetFormDataModalTipoCertidao);
  };

  const handleCloseModalAdicionarTipoCertidao = () => {
    setShowForm(false);
  }

  const handleCloseModalEditarTipoCertidao = () => {
    setShowForm(false);
  };

  function handleShowModalEditarTipoCertidao(rowData) {
    setFormDataModalTipoCertidao(rowData);
    setShowForm(true);
    setEdit(true);
  };

  // const handleSearch = async (event) => {

  //   event.preventDefault();

  //   const rowData =  codigoFiltro !== '' ? await buscarIdenCertidao(codigoFiltro) :  await pesquisaAtivos();
  //   setlistaTipoCertidao(rowData)
  // }

  const handleSearch = async (e) => {
    e.preventDefault();

    const rowData = nomeFiltro !== '' ? await buscarPeloNome(nomeFiltro) : await pesquisaAtivos();

    setlistaTipoCertidao(rowData)
  }



  const handleDelete = async (inputValue) => {
    const idenTipoCertidao = JSON.stringify(inputValue.idenTipoCertidao);
    return await deleteCertidao(idenTipoCertidao).then((res) => {
      pesquisaAtivos().then(res => {
        setlistaTipoCertidao(res);
      })
    });
  }

  return (
    <CardSeplag title="Tipos de Certidão de Crédito">

      <form onSubmit={handleSearch} className="p-col-12 p-grid">
        <div className="p-col p-grid">

          <RotuloSeplag nome="Nome Tipo" cols="12 3">
            <InputText name="nomeTipo" style={{ width: "100%" }} onChange={(e) => setNomeFiltro(e.target.value)} value={nomeFiltro} />
          </RotuloSeplag>

          <RotuloSeplag cols="12 4">
            <div className="p-col-12 p-md-4" style={{ marginTop: "20px", alignContent: "center" }}>
              <Button label="Filtrar" icon="pi pi-search" className="p-button-raised" type='submit' style={{ marginRight: "5px", width: "10rem" }} />
            </div>
          </RotuloSeplag>
        </div>
      </form>

      <TableSeplag
        dados={listaTipoCertidao}
        //onSearch={handleSearch}
        searchPlaceholder="Pesquisar tipo pelo código"
        camposTabela={camposTabela}
        hasEventoAcao
        onExcluirDado={handleDelete}
        onEditarDado={handleShowModalEditarTipoCertidao}
        onAdicionarDado={handleShowModalAdicionarTipoCertidao}
      />

      {
        showForm && (
          <ModalCadastroCertidao
            handleShowModalAdicionarTipoCertidao={handleShowModalAdicionarTipoCertidao}
            handleCloseModalAdicionarTipoCertidao={handleCloseModalAdicionarTipoCertidao}
            handleCloseModalEditarTipoCertidao={handleCloseModalEditarTipoCertidao}
            setShowForm={setShowForm}
            showForm={showForm}
            form={formDataModalTipoCertidao}
            edit={edit}
            dataTable={listaTipoCertidao}
            setDataTable={setlistaTipoCertidao}
            view={viewCamposModalTipoCertidao}
          />
        )
      }
    </CardSeplag>
  );
}

export default ManterTipoCertidao;
